export type LayerOrder = 'background' | 'foreground';

export default class BackgroundCommandEffectOptions {
  constructor(public layerOrder?: LayerOrder) {}
}
